@if (facade.selectedObserverPhoto(); as photo) {
  <div class="observer-photo-modal" role="presentation" (click)="facade.closeSelectedObserverPhoto()">
    <aside
      class="observer-photo-modal__panel"
      role="dialog"
      aria-modal="true"
      aria-label="Observer photo details"
      (click)="$event.stopPropagation()"
    >
      <div class="observer-photo-modal__header">
        <div class="observer-photo-modal__title-group">
          <span class="observer-photo-modal__title">Observer photo</span>

          @if (facade.selectedObserverPhotoGalleryCount() > 1) {
            <span class="observer-photo-modal__position">{{ facade.selectedObserverPhotoPositionLabel() }}</span>
          }
        </div>

        @if (facade.selectedObserverPhotoGalleryCount() > 1) {
          <div class="observer-photo-modal__nav" aria-label="Observer photo navigation">
            <button
              type="button"
              aria-label="Previous observer photo"
              title="Previous photo"
              (click)="facade.showPreviousObserverPhoto()"
            >
              &lsaquo;
            </button>
            <button
              type="button"
              aria-label="Next observer photo"
              title="Next photo"
              (click)="facade.showNextObserverPhoto()"
            >
              &rsaquo;
            </button>
          </div>
        }

        <button
          class="observer-photo-modal__close"
          type="button"
          aria-label="Close observer photo details"
          (click)="facade.closeSelectedObserverPhoto()"
        >
          &times;
        </button>
      </div>

      <img class="observer-photo-modal__image" [src]="photo.imageUrl" alt="Observer photo" />

      <dl class="observer-photo-modal__metadata">
        <div>
          <dt>Photo ID</dt>
          <dd>{{ photo.photoId }}</dd>
        </div>
        <div>
          <dt>Device ID</dt>
          <dd>{{ photo.deviceId || 'Unknown' }}</dd>
        </div>
        <div>
          <dt>Uploaded</dt>
          <dd>
            @if (photo.uploadedAtUtc) {
              {{ photo.uploadedAtUtc | date: 'yyyy-MM-dd HH:mm:ss' : 'UTC' }} UTC
            } @else {
              Unknown
            }
          </dd>
        </div>
        <div>
          <dt>End time</dt>
          <dd>
            @if (photo.endTimeUtc) {
              {{ photo.endTimeUtc | date: 'yyyy-MM-dd HH:mm:ss' : 'UTC' }} UTC
            } @else {
              Active
            }
          </dd>
        </div>
      </dl>
    </aside>
  </div>
}
